import * as React from "react";
import { classNames } from "src/common/classNames";

import * as styles from "./ControlWithError.module.less";

type PropsControlWithError = {
  className?: string;
  errorText?: string;
  children: React.ReactNode;
};

export const ControlWithError: React.FC<PropsControlWithError> = ({
  className,
  errorText,
  children,
}) => (
  <div className={classNames([styles.controlWithError, className])}>
    {children}
    {errorText ? (
      <div className={styles.errorText}>{errorText}</div>
    ) : undefined}
  </div>
);
